<div class="meu-perfil">
  <div class="voltar-link">
    <button type="button" (click)="goBackToProfile()">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/icons/arrow_circle_left.svg"
        alt="Voltar para Meu Perfil"
      />MEU PERFIL
    </button>
  </div>
  <div class="dados-cadastrais-container">
    <div class="form-card">
      <div class="form-header">
        <span class="material-icons form-icon">person</span>
        <div>
          <div class="form-title">Informações Pessoais</div>
          <div class="form-desc">
            Atualize seus dados de contato e informações básicas
          </div>
        </div>
      </div>
      <form (ngSubmit)="saveChanges()">
        <div class="form-group">
          <label>Nome completo</label>
          <div class="input-icon">
            <span class="material-icons">person</span>
            <input
              type="text"
              [(ngModel)]="fullName"
              name="fullName"
              required
            />
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>Telefone (WhatsApp)</label>
            <div class="input-icon">
              <span class="material-icons">call</span>
              <input
                type="text"
                [(ngModel)]="phone"
                name="phone"
                (input)="formatPhone($event)"
                maxlength="15"
                placeholder="(11) 99999-9999"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>E-mail</label>
            <div class="input-icon">
              <span class="material-icons">mail</span>
              <input
                type="email"
                [(ngModel)]="email"
                name="email"
                [title]="email"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>Cargo</label>
            <div>
              <select [(ngModel)]="position" name="position" required>
                <option value="" disabled selected>Selecione o cargo</option>
                <option *ngFor="let p of positions" [value]="p.cargo">
                  {{ p.cargo }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>Login</label>
            <div class="input-icon">
              <input type="text" [(ngModel)]="login" name="login" disabled />
            </div>
            <small class="login-info">O login não pode ser alterado</small>
          </div>
        </div>

        <button type="submit" class="btn-salvar">
          <span class="material-icons">save</span>
          Salvar alterações
        </button>
      </form>
    </div>
  </div>
</div>
